module.exports = __webpack_public_path__ + "b20cc584fc16fcf41f0532f77349f575.jpg";